import { API_URL } from '../constants/api.constants';
import axios from 'axios';
import { IFormDTO, IMedicData } from '../interfaces/form.interface';

export const fillForm = async (
  cardDTO: IFormDTO,
  hmac: string,
  file?: File,
): Promise<any> => {
  const apiURL = `${process.env.REACT_APP_API_URL}${API_URL.GDPR_FORM}`;

  if (file) {
    const formData = new FormData();
    formData.append('file', file);

    // Append cardDTO fields to formData
    Object.entries(cardDTO).forEach(([key, value]) => {
      formData.append(key, value as string);
    });

    return axios
      .post(apiURL, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'hmac-sha256': hmac,
        },
      })
      .then((res) => res.data);
  }

  return axios
    .post<IFormDTO>(apiURL, cardDTO, {
      headers: {
        'Content-Type': 'application/json',
        'hmac-sha256': hmac,
      },
    })
    .then((res) => res.data);
};

export const ping = async (hmac: string, timestamp: string): Promise<any> => {
  const apiURL = `${process.env.REACT_APP_API_URL}${API_URL.PING}`;

  return axios
    .post(
      apiURL,
      { timestamp },
      {
        headers: {
          'Content-Type': 'application/json',
          'hmac-sha256': hmac,
        },
      },
    )
    .then((res) => res.data);
};
